import { gql } from '@moonpig/web-core-graphql'

export const ModuleRecommendationsForCustomerFragment = gql`
  fragment ModuleRecommendationsForCustomer on ModuleRecommendationsForCustomer {
    title
    subtitle
    algorithm
  }
`
